module.exports = __webpack_public_path__ + "static/slide.first-1ef15ed3bf7362bbec851a963e383f8f.png";